import { Component } from "@angular/core";
import { UsuarioService } from "src/app/services/usuario-service";
import { InitProvider } from "src/app/services/init-provider";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
declare var $: any;
@Component({
  selector: "app-page-novo-representante",
  templateUrl: "./page-novo-representante.component.html",
  styleUrls: ["./page-novo-representante.component.css"],
})
export class PageNovoRepresentanteComponent  {
  list = 0;
  filter: boolean = true;
  nome: string = ''
  representantes: any[] = [];
  clientes: any[] = []
  edit: boolean = false;
  selectedRepresentante: any = {}
  selectedCliente: any = {}
  revisaCadastro: boolean
  pageable: boolean = true
  pageNumber = 1
  riskList: string[] = ["A", "B", "C", "D", "E"]
  public toastService: ToastrService;
  public form: FormGroup;
  public formCliente: FormGroup
  public aprovaId;
  public error: boolean = false
  totalPages;
  totalElements;
  constructor(
    public usuarioService: UsuarioService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public initProvider: InitProvider,
    toastService: ToastrService
  ) {
    this.toastService = toastService;
    this.form = this.formBuilder.group({
      nome: ["", [Validators.required]],
      documento: ["", [Validators.required, Validators.email]],
      status: ["", [Validators.required]],
    });
    this.formCliente = this.formBuilder.group({
      limiteCredito: [null],
      criaUsuario: [false, [Validators.required]],
      risco: ["", [Validators.required]],
    });
  }
  
  pageChangedClients(e) {
    if (this.pageNumber !== e.page) {
      this.pageNumber = e.page;
      this.getClientes();
    }
  }
  pageChangedReps(e) {
    console.log(e)
    if (this.pageNumber !== e.page) {
      this.pageNumber = e.page;
      this.getRepresentantes();
    }
  }

  setPage(value) {
    this.list = value;
    this.filter = true;
    this.pageNumber = 1
    if (value === 2) {
      this.getRepresentantes()
    } else if (value === 1) {
      this.getClientes()
    }
  }
  change(value) {
    console.log(value + "teste")
    this.form.controls.status.setValue(value)
  }
  abrirCadastro() {
    this.edit = false;
    this.filter = false;
  }

  editarCadastro(id) {
    this.usuarioService.getRepresentante(
      id,
      (res) => {
        console.log(res)
        this.selectedRepresentante = res[0]
        this.edit = true;
        this.filter = false;
      },
      (res) => console.log(res)
    )
  }

  editarCadastroCliente(id) {
    this.usuarioService.getCliente(
      id,
      (res) => {
        console.log(res)
        this.selectedCliente = res[0]
        this.edit = true;
        this.filter = false;
      },
      (res) => console.log(res)
    )
  }

  getRepresentantes(filtra = false) {
    if (filtra) {
      this.pageNumber = 1
    }
    this.usuarioService.listaRepresentante(
      { ...this.form.value, page: this. pageNumber-1},
      this.callback.bind(this),
      this.callbackError.bind(this)
    );
  }

  getClientes(filtra = false) {
    if (filtra) {
      this.pageNumber = 1
    }
    this.usuarioService.listaCliente(
      { ...this.form.value, page: this.pageNumber-1 },
      this.callback.bind(this),
      this.callbackErrorCliente.bind(this)
    );
  }

  callback(resp) {
    if (this.list === 2) {
      if(resp.length === 0){
        this.toastService.info("Representante", "Nenhum registro encontrado", {
          timeOut: 4000,
        });
      } else {

      }
      this.representantes = resp;
      this.totalPages=resp[0].paginas
      this.totalElements=resp[0].total_elementos
    } else if (this.list == 1) {
      if(resp.length === 0){
        this.toastService.info("Cliente", "Nenhum registro encontrado", {
          timeOut: 4000,
        });
    }
      this.clientes = resp.clientes
      this.totalPages=resp.paginas
      this.totalElements=resp.total_elementos
    }
  }
  callbackError(resp) {
    console.log(resp);
    Swal.fire(
      "Representante",
      `Algo deu errado. Tente novamente mais tarde`,
      "warning"
    );
  }

  callbackErrorCliente(resp) {
    console.log(resp);
    Swal.fire(
      "Cliente",
      `Algo deu errado. Tente novamente mais tarde`,
      "warning"
    );
  }

  callbackAprove(resp) {
    console.log(resp);
    Swal.fire(
      "Representante",
      `Aprovado com sucesso!`,
      "success"
    );
    this.getRepresentantes()
  }
  callbackReprove(resp) {
    console.log(resp);
    Swal.fire(
      "Representante",
      `Recusado com sucesso!`,
      "success"
    );
    this.getRepresentantes()
  }

  callbackAproveClient(resp) {
    console.log(resp);
    this.formCliente.controls.limiteCredito.setValue(null)
    this.formCliente.controls.criaUsuario.setValue(false)
    this.formCliente.controls.risco.setValue('')
    Swal.fire(
      "Cliente",
      `Aprovado com sucesso!`,
      "success"
    );
    this.getClientes()
  }
  callbackReproveClient(resp) {
    console.log(resp);
    this.formCliente.controls.limiteCredito.setValue(null)
    this.formCliente.controls.criaUsuario.setValue(false)
    this.formCliente.controls.risco.setValue('')
    Swal.fire(
      "Cliente",
      `Recusado com sucesso!`,
      "success"
    );
    this.getClientes()
  }

  selectaprovar(id, nome, revisa = false, risco = '', limiteCredito = null) {
    console.log(limiteCredito)
    this.aprovaId = id;
    this.revisaCadastro = revisa
    this.nome = nome
    this.formCliente.controls.risco.setValue(risco)
    this.formCliente.controls.limiteCredito.setValue(limiteCredito)
  }

  aprovar() {
    this.usuarioService.aprovaRepresentante(
      {
        funcionario: this.aprovaId,
        aprovado: true,
        usuario: this.initProvider.usuario.id,
        cliente: null,
        tipo: "FUNCIONARIO",
        cria_usuario: true,
        limite_credito: null
      },
      this.callbackAprove.bind(this),
      this.callbackError.bind(this)
    );
  }

  aprovarCliente() {
    if (this.revisaCadastro) {
      Swal.fire(
        "Cliente ",
        `Não foi possível aprovar cliente. Dados de cadastro inválidos`,
        "error"
      );
      $("#confirmAprovaClienteModal").modal("hide");
      return null
    }
    if (this.formCliente.status === "VALID") {
      this.usuarioService.aprovaRepresentante(
        {
          funcionario: null,
          aprovado: true,
          usuario: this.initProvider.usuario.id,
          cliente: this.aprovaId,
          tipo: "CLIENTE",
          cria_usuario: this.formCliente.value.criaUsuario,
          limite_credito: this.formCliente.value.limiteCredito === 0 ? null : this.formCliente.value.limiteCredito,
          risco: this.formCliente.value.risco
        },
        this.callbackAproveClient.bind(this),
        this.callbackError.bind(this)
      );
      this.error = false
      $("#confirmAprovaClienteModal").modal("hide");
    } else {
      this.error = true         
    }
  }

  reprovar() {
    this.usuarioService.aprovaRepresentante(
      {
        funcionario: this.aprovaId,
        aprovado: false,
        usuario: this.initProvider.usuario.id,
        cliente: null,
        tipo: "FUNCIONARIO",
        cria_usuario: false,
        limite_credito: null
      },
      this.callbackReprove.bind(this),
      this.callbackError.bind(this)
    );
    $("#confirmAprovaClienteModal").modal("hide");
  }
  reprovarCliente() {
    console.log(this.formCliente.value)
    this.usuarioService.aprovaRepresentante(
      {
        funcionario: null,
        aprovado: false,
        usuario: this.initProvider.usuario.id,
        cliente: this.aprovaId,
        tipo: "CLIENTE",
        cria_usuario: this.formCliente.value.criaUsuario,
        limite_credito: this.formCliente.value.limiteCredito === 0 ? null : this.formCliente.value.limiteCredito
      },
      this.callbackReproveClient.bind(this),
      this.callbackError.bind(this)
    );
    $("#confirmAprovaClienteModal").modal("hide");
  }

}
